import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class Competence extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'competence'}
            title={ t('support.procedure.P5.title') }
            exportTitle={ t('support.procedure.P5.exportTitle') }
            exportFileName={'competence.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Competence);